module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/tj.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Ftj.png
// module id = k3JB
// module chunks = 93